import Msg from "./Msg";
import Menu from "./Menu";

const Meals = (props) => {

    return (
    <section>
      <Msg />
      <Menu />
    </section>
  );
};

export default Meals;
